import { Navigate, useLocation } from "react-router-dom";
import { useUserStore } from "../modules/User/store";
import { useEffect, useState } from "react";

interface CheckingPermissionsProps {
  children: React.ReactNode;
  requiredPermission?: string;
  requiredRole?: "admin" | "employee" | "customer" | "stylist";
}

const CheckingPermissions = (props: CheckingPermissionsProps): JSX.Element => {
  const { children, requiredPermission, requiredRole } = props;
  const location = useLocation();
  const { userData, getCurrentUserData } = useUserStore();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      if (!userData) {
        await getCurrentUserData();
      }
      setIsChecking(false);
    };

    checkAccess();
  }, [userData, getCurrentUserData]);

  if (isChecking) {
    return <div>Проверка прав доступа...</div>;
  }

  if (!userData) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  if (userData.role === "admin") {
    return <>{children}</>;
  }

  if (userData.role != "customer") {
    if (!requiredPermission) {
      return <>{children}</>;
    }

    if (userData.permissions?.includes(requiredPermission)) {
      return <>{children}</>;
    }

    const firstAvailablePermission = userData.permissions?.[0];
    if (firstAvailablePermission) {
      return <Navigate to={`/${firstAvailablePermission}`} replace />;
    }

    return <Navigate to="/no_access" replace />;
  }

  if (requiredRole && userData.role !== requiredRole) {
    return <Navigate to="/no_access" replace />;
  }

  if (requiredPermission && !userData.permissions?.includes(requiredPermission)) {
    return <Navigate to="/no_access" replace />;
  }

  if (userData.role === "customer" && (requiredPermission || requiredRole)) {
    return <Navigate to="/no_access" replace />;
  }

  return <>{children}</>;
};

export default CheckingPermissions;